"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_options_core_1 = require("owa-options-core");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveInlinePreviewsOption')(function saveInlinePreviewsOption(isEnabled, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, isFeatureEnabled;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    isFeatureEnabled = isEnabled === void 0 ? optionState.isEnabled : isEnabled;
                    userOptions.ShowInlinePreviews = isFeatureEnabled;
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'ShowInlinePreviews',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.ShowInlinePreviews,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveInlinePreviewsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inline-previews-option/lib/actions/saveInlinePreviewsOption.js
// module id = 5097
// module chunks = 2